import { render, staticRenderFns } from "./BusinessRole.vue?vue&type=template&id=84fe2c4e&scoped=true&"
import script from "./BusinessRole.vue?vue&type=script&lang=js&"
export * from "./BusinessRole.vue?vue&type=script&lang=js&"
import style0 from "./BusinessRole.vue?vue&type=style&index=0&id=84fe2c4e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84fe2c4e",
  null
  
)

export default component.exports